export const mobileWidth = 992

export const SERVERTYPE = {
  mt5: 1,
  mt4: 2,
  sirix: 3,
  xoh: 5,
  fortex: 4
}

export const SERVERTYPETEXT = {
  1: 'mt5',
  2: 'mt4',
  3: 'sirix',
  4: 'fortex',
  5: 'xoh'
}

export const enumIcons = {
  1: 'MT5',
  2: 'MT4',
  3: 'sirix',
  4: 'fortex',
  5: 'XOH'
}

export const MENUICONMAP = {
  walletWater: 'wallet-water',
  dealHistory: 'trade-history',
  holdOrder: 'holdorder',
  auditRecord: 'audit-record',
  wallet: 'my-wallet',
  limitOrder: 'limit-order',
  personal: 'person-center',
  moneyPassword: 'money-password',
  Download: 'platform-download',
  'account-groups': 'account-groups-icon',
  news: 'news-icon',
  'my-commission': 'Mycommission-icon',
  myInvest: 'myInvest-icon',
  inBank: 'inBank-icon',
  myshare: 'myshare-icon',
  genCenter: 'genCenter-icon',
  'client-rebate': 'client-rebate-icon',
  customerlimitOrder: 'customerLimitOrder-icon',
  'clint-walletWater': 'clint-walletWater-icon',
  clientList: 'clientList-icon',
  mtIdJR: 'mtIdJR-icon',
  'client-mtwater': 'client-mtwater-icon',
  'client-account': 'client-account-icon',
  'client-relations': 'client-relations-icon',
  customerHoldOrder: 'customerHoldOrder-icon',
  ticket: 'ticket-icon',
  IBApplication: 'IBApplication-icon',
  index: 'index-icon',
  deposit: 'deposit-icon',
  'with-draw': 'with-draw-icon',
  'payment-orders': 'Mycommission-icon',
  customerDealHistory: 'customerDealHistory-icon'
}

export const operaTypeList = [
  {
    text: 'AuditRecord.Deposit',
    id: '1'
  },
  {
    text: 'AuditRecord.Withdrawal',
    id: '2'
  },
  {
    text: 'mtFundsFlow.sysDeposit',
    id: '3'
  },
  {
    text: 'mtFundsFlow.sysWithdrawal',
    id: '4'
  },
  {
    text: 'mtFundsFlow.sysCreditDeposit',
    id: '5'
  },
  {
    text: 'mtFundsFlow.sysCreditWithdrawal',
    id: '6'
  },
  {
    text: 'mtFundsFlow.Commission',
    id: '7'
  },
  {
    text: 'mtFundsFlow.deposit',
    id: '8'
  },
  {
    text: 'mtFundsFlow.withdraw',
    id: '9'
  }
]

export const statusBtnColor = {
  '-2': 'info',
  '-1': 'warning',
  0: 'danger',
  1: 'success',
  2: 'warning'
}

export const infoTextArr = [
  'Personal.PersonalInformation',
  'Personal.finance',
  'Personal.identity',
  'Personal.agreement'
]

export const statusTypeMap = {
  '-2': 'Personal.NotSubmitted',
  '-1': 'Personal.underReview',
  0: 'Personal.AuditNotPassed',
  1: 'Personal.examinationPassed',
  2: 'Personal.underReview'
}

export const protocolType = {
  0: 'Personal.confirm',
  1: 'Personal.confirmed'
}

export const AuditRecordList = [
  {
    text: 'AuditRecord.Pending',
    id: 2
  },
  {
    text: 'Personal.underReview',
    id: -1
  },
  {
    text: 'Personal.examinationPassed',
    id: 1
  },
  {
    text: 'Personal.AuditNotPassed',
    id: 0
  },
  {
    text: 'Personal.NotSubmitted',
    id: -2
  }
]

// 外国人名字正则
export const ForeignUserNameRegex = /^([a-zA-Z'’.·]+\s)*[a-zA-Z'’.·]+$/
// 手机号正则验证
export const phoneReg = /^1[3|4|5|6|7|8|9][0-9]\d{8}$/
// 邮箱正则
export const mailReg = /^([A-Za-z0-9_\-.])+@([A-Za-z0-9_\-.])+\.([A-Za-z]{2,8})$/

export const withDrawTextEnum = {
  outInterTransfer: 'i',
  outBankRemit: 'b',
  outCrypto: 'c',
  outPayID: 'P'
}

export const withDrawNumberEnum = {
  i: 1,
  b: 2,
  c: 6,
  P: 13
}

export const verifyStatusEnum = [
  {
    text: 'AuditRecord.Pending',
    id: '2'
  },
  {
    text: 'AuditRecord.through',
    id: '1'
  },
  {
    text: 'Common.cancel',
    id: '-1'
  },
  {
    text: 'AuditRecord.Refuse',
    id: '0'
  }
]

export const settinglistEnum = {
  1: 'pointsMall.Deposit',
  2: 'pointsMall.transaction',
  3: 'pointsMall.Inviteuserstoregister',
  4: 'pointsMall.Invitetocreatetradingaccount',
  5: 'pointsMall.Frienddeposit'
}

export const kycStatusEnum = {
  // 0 拒绝，1 通过，-1 待审，-2 未提交
  '-2': 'common.notsubmitted',

  '-1': 'AuditRecord.Pending', // 待审
  0: 'Personal.AuditNotPassed', // 拒绝 未通过
  1: 'Personal.examinationPassed' // 通过
}

export const iconMap = {
  JPY: 'JPN',
  CNY: 'CHN',
  INR: 'IND',
  IDR: 'IDN',
  USD: 'USA',
  EUR: 'EUR',
  PHP: 'PHL',
  Cents: 'USA',
  ETH: 'ETH',
  USDT: 'USDT',
  BTC: 'BTC',
  MYR: 'MYS',
  AUD: 'AUS',
  VND: 'VND',
  THB: 'THB'
}

export const typeMap = {
  binfo: 'personal',
  finfo: 'finance',
  iinfo: 'identity',
  pinfo: 'agreement'
}

export const infoTextMap = {
  binfo: 'Personal.PersonalInformation',
  finfo: 'Personal.finance',
  iinfo: 'Personal.identity',
  pinfo: 'Personal.agreement'
}

export const protocolTypeMap = {
  '-2': 'Personal.confirm',
  1: 'Personal.confirmed'
}
